import { useEffect, useState } from "react";
import { Yacht } from "../../Yachts/model";
import { RelocationButton } from "./RelocationButton";
import { YachtsSelection } from "./YachtsSelection";
import { useToast } from "@/src/components/ui/use-toast";
import { useFetch } from "@/src/lib/useFetch";

type YachtSectionProps = {
  loadYachts: () => Promise<Yacht[]>;
};

export function YachtsSection({ loadYachts }: YachtSectionProps) {
  const [selectedYachtIds, setSelectedYachtIds] = useState([] as string[]);
  const [yachts, setYachts] = useState([] as Yacht[]);
  const { toast } = useToast();
  const { fetch } = useFetch();

  useEffect(() => {
    loadYachts().then(setYachts);
  }, []);

  const handleRelocate = async (destinationId: string, destinationType: string) => {
    try {
      // To be implemented: call API to relocate the yachts
      // Make API call based on the destination type
      let endpoint = "";

      if (destinationType === "location") {
        endpoint = `/api/locations/locations/${destinationId}/yachts`;
      } else if (destinationType === "country") {
        endpoint = `/api/locations/countries/${destinationId}/yachts`;
      } else if (destinationType === "town") {
        endpoint = `/api/locations/towns/${destinationId}/yachts`;
      }

      await fetch(endpoint, "POST", { yachtIds: selectedYachtIds });

      // Refresh the yacht list after relocation
      const updatedYachts = await loadYachts();
      setYachts(updatedYachts);

      // Clear selection after successful relocation
      setSelectedYachtIds([]);

      toast({
        title: "Success",
        description: `Successfully relocated ${selectedYachtIds.length} yacht(s)`,
      });
    } catch (error) {
      console.error("Failed to relocate yachts:", error);
      toast({
        title: "Error",
        description: "Failed to relocate yachts",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="rounded-2xl shadow-md bg-white p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">
          Yachts - {yachts.length} total - {selectedYachtIds.length} selected
        </h2>
        <RelocationButton ids={selectedYachtIds} onRelocate={handleRelocate} />
      </div>
      <YachtsSelection yachts={yachts} selectedYachtIds={selectedYachtIds} onSelectionChange={setSelectedYachtIds} />
    </div>
  );
}
